import apiFetch from '../../apiFetch'

export default function (dossierId, token) {
  return apiFetch({ endPoint: `Dossier/RegistrationDelivery/${dossierId}/dependants`, method: 'GET', token: token })
}
